<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">
            <el-row>
                <el-col :span="12"><el-form-item label="类型" prop="isHz">
                    <el-radio-group v-model="dataForm.isHz">
                        <el-radio :label="0">合同工</el-radio>
                        <el-radio :label="1">划转工</el-radio>
                        <el-radio :label="2">校园</el-radio>
                    </el-radio-group>
                </el-form-item></el-col>
                <el-col :span="12"><el-form-item label="名称" prop="name">
                    <el-input clearable v-model="dataForm.name" ></el-input>
                </el-form-item></el-col>
            </el-row>
           <div v-if="dataForm.isHz===0">
               <el-row>
                   <el-col :span="12"><el-form-item label="岗位工资" prop="gwGz">
                       <el-input clearable v-model="dataForm.gwGz" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12"> <el-form-item label="补差"  prop="bc">
                       <el-input clearable v-model="dataForm.bc" ></el-input>
                   </el-form-item></el-col>
               </el-row>
               <el-row>
                   <el-col :span="12"> <el-form-item label="考核奖"  prop="khj">
                       <el-input clearable v-model="dataForm.khj" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12">  <el-form-item label="扣奖"  prop="kj">
                       <el-input clearable v-model="dataForm.kj" ></el-input>
                   </el-form-item></el-col>
               </el-row>
               <el-row>
                   <el-col :span="12"><el-form-item label="一次性" prop="yicixing">
                       <el-input clearable v-model="dataForm.yicixing" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12"><el-form-item label="职务津贴" prop="zwjt">
                       <el-input clearable v-model="dataForm.zwjt" ></el-input>
                   </el-form-item></el-col>
               </el-row>

               <el-row>
                   <el-col :span="12"> <el-form-item label="津贴1" prop="jt1">
                       <el-input clearable v-model="dataForm.jt1" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12">  <el-form-item label="津贴2" prop="jt2">
                       <el-input clearable v-model="dataForm.jt2" ></el-input>
                   </el-form-item></el-col>
               </el-row>
               <el-row>
                   <el-col :span="12"> <el-form-item label="津贴3" prop="jt3">
                       <el-input clearable v-model="dataForm.jt3" ></el-input>
                   </el-form-item></el-col>

               </el-row>

               <el-row>
                   <el-col :span="12"><el-form-item label="饭贴" prop="ft">
                       <el-input clearable v-model="dataForm.ft" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12">  <el-form-item label="其他1" prop="qt1">
                       <el-input clearable v-model="dataForm.qt1" ></el-input>
                   </el-form-item></el-col>
               </el-row>
               <el-row>
                   <el-col :span="12"><el-form-item label="其他2" prop="qt2">
                       <el-input clearable v-model="dataForm.qt2" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12"> <el-form-item label="嘉奖" prop="jj">
                       <el-input clearable v-model="dataForm.jj" ></el-input>
                   </el-form-item></el-col>
               </el-row>
               <el-row>
                   <el-col :span="12"> <el-form-item label="高温费" prop="gwf">
                       <el-input clearable v-model="dataForm.gwf" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12">  <el-form-item label="独生子女" prop="dszn">
                       <el-input clearable v-model="dataForm.dszn" ></el-input>
                   </el-form-item></el-col>
               </el-row>
               <el-row>
                   <el-col :span="12">  <el-form-item label="代扣" prop="dk">
                       <el-input clearable v-model="dataForm.dk" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12">   <el-form-item label="工会费" prop="ghf">
                       <el-input clearable v-model="dataForm.ghf" ></el-input>
                   </el-form-item></el-col>
               </el-row>
           </div>
            <div v-else-if="dataForm.isHz===1">
                <el-row>
                    <el-col :span="12"><el-form-item label="岗位工资" prop="gwGz">
                        <el-input clearable v-model="dataForm.gwGz" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"> <el-form-item label="企业年金"  prop="qynj">
                        <el-input clearable v-model="dataForm.qynj" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"><el-form-item label="绩效工资"  prop="jxgz">
                        <el-input clearable v-model="dataForm.jxgz" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="住房补贴"   prop="zfbt">
                        <el-input clearable v-model="dataForm.zfbt" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"><el-form-item label="岗位津贴"  prop="gwjt">
                        <el-input clearable v-model="dataForm.gwjt" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="医疗备用金"  prop="lybyj">
                        <el-input clearable v-model="dataForm.lybyj" ></el-input>
                    </el-form-item></el-col>
                </el-row>

                <el-row>
                    <el-col :span="12"><el-form-item label="一次性" prop="yicixing">
                        <el-input clearable v-model="dataForm.yicixing" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="职务津贴" prop="zwjt">
                        <el-input clearable v-model="dataForm.zwjt" ></el-input>
                    </el-form-item></el-col>
                </el-row>

                <el-row>
                    <el-col :span="12"> <el-form-item label="津贴1" prop="jt1">
                        <el-input clearable v-model="dataForm.jt1" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12">  <el-form-item label="津贴2" prop="jt2">
                        <el-input clearable v-model="dataForm.jt2" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"> <el-form-item label="津贴3" prop="jt3">
                        <el-input clearable v-model="dataForm.jt3" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="津贴4"  prop="jt4">
                        <el-input clearable v-model="dataForm.jt4" ></el-input>
                    </el-form-item></el-col>
                </el-row>

                <el-row>
                    <el-col :span="12"><el-form-item label="饭贴" prop="ft">
                        <el-input clearable v-model="dataForm.ft" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12">  <el-form-item label="其他1" prop="qt1">
                        <el-input clearable v-model="dataForm.qt1" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"><el-form-item label="其他2" prop="qt2">
                        <el-input clearable v-model="dataForm.qt2" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"> <el-form-item label="嘉奖" prop="jj">
                        <el-input clearable v-model="dataForm.jj" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"> <el-form-item label="高温费" prop="gwf">
                        <el-input clearable v-model="dataForm.gwf" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12">  <el-form-item label="独生子女" prop="dszn">
                        <el-input clearable v-model="dataForm.dszn" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">  <el-form-item label="代扣" prop="dk">
                        <el-input clearable v-model="dataForm.dk" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12">   <el-form-item label="工会费" prop="ghf">
                        <el-input clearable v-model="dataForm.ghf" ></el-input>
                    </el-form-item></el-col>
                </el-row>
            </div>
            <div v-else-if="dataForm.isHz===2">
                <el-row>
                    <el-col :span="12"><el-form-item label="基本工资" prop="gwGz">
                        <el-input clearable v-model="dataForm.gwGz" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="值班津贴"  prop="gwjt">
                        <el-input clearable v-model="dataForm.jt1" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"><el-form-item label="叠加护校津贴"  prop="gwjt">
                        <el-input clearable v-model="dataForm.jt2" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"> <el-form-item label="考核奖"  prop="khj">
                        <el-input clearable v-model="dataForm.khj" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"><el-form-item label="饭贴" prop="ft">
                        <el-input clearable v-model="dataForm.ft" ></el-input>
                    </el-form-item></el-col>
                </el-row>

            </div>
            <el-row>
                <el-col :span="12"> <el-form-item label="社保基数" prop="sbjs">
                    <el-input clearable v-model="dataForm.sbjs" ></el-input>
                </el-form-item></el-col>
                <el-col :span="12"> <el-form-item label="公积金基数" prop="gjjjs">
                    <el-input clearable v-model="dataForm.gjjjs" ></el-input>
                </el-form-item></el-col>
            </el-row>

        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {

        data () {
            const validateNumber = (rule, value, callback) => {
                if(value) {
                    var patrn = /^\d+(\.\d+)?$/;
                    if (!patrn.exec(value)) {
                        callback(new Error('请填写数字'))
                    } else {
                        callback()
                    }
                } else callback()
            }
            return {
                //表单验证规则
                rules: {
                    isHz: [{required: true, trigger: 'blur', message: '请选择类型'}],
                    gwGz: [{required: true, trigger: 'blur', message: '请输入岗位工资'},{validator:validateNumber,trigger: 'blur'}],
                    name: [{required: true, trigger: 'blur', message: '请输入名称'}],
                    yicixing: [{validator:validateNumber,trigger: 'blur'}],
                    zwjt: [{validator:validateNumber,trigger: 'blur'}],
                    jt1: [{validator:validateNumber,trigger: 'blur'}],
                    jt2: [{validator:validateNumber,trigger: 'blur'}],
                    jt3: [{validator:validateNumber,trigger: 'blur'}],
                    jt4: [{validator:validateNumber,trigger: 'blur'}],
                    jxgz: [{validator:validateNumber,trigger: 'blur'}],
                    gwjt: [{validator:validateNumber,trigger: 'blur'}],
                    lybyj: [{validator:validateNumber,trigger: 'blur'}],
                    zfbt: [{validator:validateNumber,trigger: 'blur'}],
                    ft: [{validator:validateNumber,trigger: 'blur'}],
                    qt1: [{validator:validateNumber,trigger: 'blur'}],
                    qt2: [{validator:validateNumber,trigger: 'blur'}],
                    jj: [{validator:validateNumber,trigger: 'blur'}],
                    gwf: [{validator:validateNumber,trigger: 'blur'}],
                    bj: [{validator:validateNumber,trigger: 'blur'}],
                    sj: [{validator:validateNumber,trigger: 'blur'}],
                    dszn: [{validator:validateNumber,trigger: 'blur'}],
                    dk: [{validator:validateNumber,trigger: 'blur'}],
                    ghf: [{validator:validateNumber,trigger: 'blur'}],
                    qynj: [{validator:validateNumber,trigger: 'blur'}],
                    bc: [{validator:validateNumber,trigger: 'blur'}],
                    khj: [{validator:validateNumber,trigger: 'blur'}],
                    kj: [{validator:validateNumber,trigger: 'blur'}],
                    sbjs: [{required: true, trigger: 'blur', message: '请输入社保基数',},{validator:validateNumber,trigger: 'blur'}],
                    gjjjs: [{required: true, trigger: 'blur', message: '请输入公积金基数',},{validator:validateNumber,trigger: 'blur'}],
                },
                visible: false,
                menuList: [],
                customerList:[],
                dataForm: {
                id: '',
                name: '',
                isHz: '',
                gwGz: '',
                yicixing: '',
                zwjt: '',
                jt1: '',
                jt2: '',
                jt3: '',
                jt4: '',
                jxgz: '',
                gwjt: '',
                jbf: '',
                lybyj: '',
                zfbt: '',
                ybf: '',
                ft: '',
                qt1: '',
                qt2: '',
                jj: '',
                gwf: '',
                bj: '',
                sj: '',
                dszn: '',
                dk: '',
                ghf: '',
                qynj: '',
                bc: '',
                khj: '',
                kj: '',
                sbjs: '',
                gjjjs: '',
                }
            }
        },
        methods: {
            init (id) {
                this.dataForm.id = id
                this.visible = true
                this.$nextTick
                (() => {
                    this.$refs['dataForm'].resetFields()
                    if(this.dataForm.id) {
                        this.$http
                        ({
                            url: '/bjba/salary/template/info/'+this.dataForm.id,
                            method: 'get'
                        }).then(({data}) => {
                            this.dataForm.id    = data.data.id
                            this.dataForm.isHz    = data.data.isHz
                            this.dataForm.gwGz    = data.data.gwGz
                            this.dataForm.yicixing    = data.data.yicixing
                            this.dataForm.zwjt    = data.data.zwjt
                            this.dataForm.jt1    = data.data.jt1
                            this.dataForm.jt2    = data.data.jt2
                            this.dataForm.jt3    = data.data.jt3
                            this.dataForm.jt4    = data.data.jt4
                            this.dataForm.jxgz    = data.data.jxgz
                            this.dataForm.gwjt    = data.data.gwjt
                            this.dataForm.jbf    = data.data.jbf
                            this.dataForm.lybyj    = data.data.lybyj
                            this.dataForm.zfbt    = data.data.zfbt
                            this.dataForm.ybf    = data.data.ybf
                            this.dataForm.ft    = data.data.ft
                            this.dataForm.qt1    = data.data.qt1
                            this.dataForm.qt2    = data.data.qt2
                            this.dataForm.jj    = data.data.jj
                            this.dataForm.gwf    = data.data.gwf
                            this.dataForm.bj    = data.data.bj
                            this.dataForm.sj    = data.data.sj
                            this.dataForm.dszn    = data.data.dszn
                            this.dataForm.dk    = data.data.dk
                            this.dataForm.ghf    = data.data.ghf
                            this.dataForm.qynj    = data.data.qynj
                            this.dataForm.bc    = data.data.bc
                            this.dataForm.khj    = data.data.khj
                            this.dataForm.kj    = data.data.kj
                            this.dataForm.sbjs    = data.data.sbjs
                            this.dataForm.gjjjs    = data.data.gjjjs
                            this.dataForm.name = data.data.name
                        })
                    }
                })

            },
            // 表单提交
            // 表单提交
            dataFormSubmit () {
                console.log(11111111111)
              this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.$http
                    ({
                        url: `/bjba/salary/template/save`,
                        method: 'post',
                        data: this.dataForm
                    }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500
                         })
                        this.visible = false
                        this.$emit
                        ('refreshDataList')
                    } else if(data && data.code === 500) {
                        this.$message
                        ({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                    })
                    }
                })
            }
        }
    }
</script>
